module.exports = __webpack_public_path__ + "img/Telegram-512.49d5eb07.webp";